import React from 'react';

const PVSPageLayout = ({ children, className = '' }) => (
  <div className={`min-h-screen bg-pvs-bg relative ${className}`}>
    <svg width="0" height="0" style={{ position: 'absolute' }}>
      <defs>
        <linearGradient id="icon-two-tone" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4ade80" />
          <stop offset="50%" stopColor="#a3e635" />
          <stop offset="100%" stopColor="#ffd700" />
        </linearGradient>
      </defs>
    </svg>

    <div
      className="fixed inset-0 pointer-events-none z-[1] flex items-center justify-center overflow-hidden"
      style={{ top: '18%' }}
    >
      <div className="absolute" style={{ width: '900px', height: '900px', borderRadius: '50%', border: '1px solid rgba(74, 222, 128, 0.04)' }} />
      <div className="absolute" style={{ width: '650px', height: '650px', borderRadius: '50%', border: '1px solid rgba(74, 222, 128, 0.07)' }} />
      <div className="absolute" style={{ width: '420px', height: '420px', borderRadius: '50%', border: '1px solid rgba(74, 222, 128, 0.10)' }} />
      <div
        className="text-center select-none"
        style={{
          fontSize: 'clamp(5rem, 18vw, 12rem)',
          fontWeight: 900,
          lineHeight: 0.85,
          color: 'rgba(255, 255, 255, 0.06)',
          letterSpacing: '-0.02em',
        }}
      >
        PVS<br/>LIMITED
      </div>
    </div>

    <div className="relative z-[2]">
      {children}
    </div>
  </div>
);

export default PVSPageLayout;
